import { render, staticRenderFns } from "./SupportDashboard.vue?vue&type=template&id=1bb8e4e0"
import script from "./SupportDashboard.vue?vue&type=script&lang=js"
export * from "./SupportDashboard.vue?vue&type=script&lang=js"
import style0 from "./SupportDashboard.vue?vue&type=style&index=0&id=1bb8e4e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports